module.exports = __webpack_public_path__ + "img/request.0cf258c0.svg";